import React, {useContext} from "react";
import {observer} from "mobx-react-lite";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  Col, CustomInput,
  Form,
  FormGroup, Input, Label, Row, Table, UncontrolledTooltip,
} from "reactstrap";
import {FormattedMessage} from "react-intl";
import GroupSelect from "../../elements/groups/GroupSelect";
import DimensionsMultiSelect from "../../elements/dimensions/multi-select/dimensionsMultiSelect";
import Select from "react-select";
import {batchEditAdvancedConfigs} from "../../../utils/constants";
import ScanbuyTable, {TableColumn} from "../../tables/ScanbuyTable";
import {browserHistory} from "mobx-state-router";
import {useAuth0} from "@auth0/auth0-react";
import {StateContext} from "../../../App";
import dayjs from "dayjs";
import AuditSelect from "../../elements/audit/AuditSelect";


export const buildAuditColumns = (componentStore, auditOptions) => {
  const c1 = TableColumn.create({
    name: 'Date',
    property: 'date',
    width: '20%',
  });
  c1.setSelector((row) => {
    const formattedDate = dayjs(row.date).format('YYYY-MM-DD HH:mm:ss');
    return formattedDate;
  });

  const c2 = TableColumn.create({
    name: 'Status',
    property: 'status',
    width: '15%',
  });
  c2.setSelector((row) => {
    const match = auditOptions.find(option => option.id === row.status);
    return match?.label || row.status;
  });

  const c3 = TableColumn.create({
    name: 'Author',
    property: 'author',
    width: '25%',
  });
  c3.setSelector((row) => {
    return (
      <>
          {row.author}
      </>
    );
  });

  const c4 = TableColumn.create({
    name: 'Note',
    property: 'note',
    width: '40%',
    sortable: false,
  });
  c4.setSelector((row) => {
    return row.note || "N/A";
  });

  return [c1, c2, c3, c4];
};


const AuditView = observer(  ({store}) => {
  const {user} = useAuth0();
  store.setUser(user);

  //TODO: PATTERN VIOLATION - setOnSelectChanges called on every render
  // See correct pattern: Call in route onEnter (src/routes/codes/index.js) or as MST action
  store.setOnSelectChanges()

  return (
    <>
      <Card>
        <CardBody>
          <Form>
            <FormGroup row>
              <Col sm={4}>
                <Label for="auditSelect">Audit</Label>
                {/*<Select*/}
                {/*  id="auditSelect"*/}
                {/*  options={[*/}
                {/*    {value: 'audit1', label: 'None'},*/}
                {/*    {value: 'audit2', label: 'Verified'},*/}
                {/*    {value: 'audit3', label: 'Issue'},*/}
                {/*  ]}*/}
                {/*  classNamePrefix="select"*/}
                {/*  onChange={(data) => store.setAudit(data)}*/}
                {/*  value={store?.selectedAudit}*/}
                {/*/>*/}
                <AuditSelect store={store?.auditSelectStore} disabled={store?.isView}/>
              </Col>
              <Col sm={8}>
                <Label for="noteText">Note</Label>
                <Input
                  type="textarea"
                  name="note"
                  id="noteText"
                  onChange={(e) => store.setNote(e.target.value)}
                  value={store?.note}
                  readOnly={store?.isView}
                />
              </Col>
            </FormGroup>
          </Form>
          <Row>
            {/*<ScanbuyTable*/}
            {/*  columns={store?.columns}*/}
            {/*  store={store}*/}
            {/*/>*/}
            <Col>
              {store?.audits.length > 0 ?
                <ScanbuyTable
                  columns={store?.columns}
                  store={store}
                />
                :
                <ScanbuyTable
                  columns={store?.columns}
                  store={store}
                />
              }
            </Col>
          </Row>
          <Row className="p-1">
            <Col sm={2}>
              <Button color="secondary" id="cancel-btn" onClick={async () => {
                store?.notifyModalCallBack();
              }}> <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.cancel.defaultMessage"/> </Button>
            </Col>

            {!store?.isView && (
              <Col sm={10} className="text-right">
                <Button id="save-btn" outline color="primary" disabled={store.isSaveDisabled()}
                        onClick={async () => {
                          await store?.saveAuditNotes();
                        }}>Save</Button>
              </Col>
            )}
          </Row>
        </CardBody>
      </Card>
    </>
  )
})
export default AuditView;
